import ES from './es';
import EN from './en';

const telephone = {
    ES,
    EN
};

export default telephone;
